import { useState } from "react";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
// import Tooltip from "react-bootstrap/Tooltip";
import { TooltipStandard } from "./Utility/TooltipStandard";

/**
 * @param {string} label
 */

const renderTooltip = (label) => (props) =>
  (
    <TooltipStandard id="button-tooltip" {...props}>
      {label}
    </TooltipStandard>
  );

/**
 * @param {Object} props
 * @param {string} props.label - The text to display in the tooltip.
 * @param {string?} props.placement - The placement of the Overlay in relation to it's target.
 * Default: 'top'
 *
 * 'auto-start' | 'auto' | 'auto-end' | 'top-start' | 'top' | 'top-end' | 'right-start' | 'right' | 'right-end' | 'bottom-end' | 'bottom' | 'bottom-start' | 'left-end' | 'left' | 'left-start'
 * @param {React.ReactNode} props.children
 * @returns {JSX.Element}
 */

function OverlayTooltip({
  label,
  placement = "top",
  children,
  initialShow,
  show: stateShow,
  ref,
  ...rest
}) {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <div onMouseOver={handleShow} onMouseLeave={handleClose}>
      <OverlayTrigger
        placement={placement}
        overlay={renderTooltip(label)}
        show={show}
        {...rest}
      >
        {children}
      </OverlayTrigger>
    </div>
  );
}

export default OverlayTooltip;
